// Module
var code = "<h1 class=\"heading--isInteriorPageHeading\">MANAGE YOUR LOANS</h1> <p>Be smart and stay smart when it comes to repaying your student loans. </p> ";
// Exports
export default code;